import {
  RANDOM_ARTWORK,
  RANDOM_ARTWORK_RESET,
} from "../actions/randomArtworkAction";

const initialState = {
  data: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RANDOM_ARTWORK:
      return {
        ...state,
        data: action.params,
      };
    case RANDOM_ARTWORK_RESET:
      return {
        ...state,
        data: null,
      };

    default:
      return state;
  }
}
